import Homepage from "../components/Homepage";
import {Link} from "react-router-dom";

export default function Home(){
    return(
        <Homepage />
    )
}